import React from "react";

import CentreWrapper from "../component/CentreWrapper";

/**
 * Default, unbranded login page layout
 *
 */
const LoginDefault = ({ children }) => (
    <React.Fragment>
        <CentreWrapper>{children}</CentreWrapper>
    </React.Fragment>
);

export default LoginDefault;
